import { loadIndexes } from '@data/indexes';
import type { VoiePrestige } from '@data/schemas';
import { normalize } from '@features/search';
import { html } from 'lit';

export async function renderPrestigePage(): Promise<unknown> {
  const idx = await loadIndexes();
  const voies = idx.bdd.voiesPrestige.voies_prestige;

  const matches = (v: VoiePrestige, q: string): boolean =>
    normalize(`${v.nom} ${v.categorie}`).includes(q);

  const render = (v: VoiePrestige) => html`
    <div class="prestige-voie">
      <cof2-accordion label=${v.nom}>
        <div class="prestige-voie-inner">
          <span class="prestige-categorie">${v.categorie}</span>
          <div class="profil-rangs">
            ${v.rangs.map(
              (r) => html`
              <div class="profil-rang">
                <div class="profil-rang-header">
                  <span class="profil-rang-num">${r.rang}</span>
                  <span class="profil-rang-name">${r.nom}</span>
                  ${r.type ? html`<span class="profil-rang-type">${r.type}</span>` : null}
                </div>
                <p class="profil-rang-desc">${r.description}</p>
              </div>
            `,
            )}
          </div>
        </div>
      </cof2-accordion>
    </div>
  `;

  return html`
    <div class="prestige-page">
      <header class="prestige-header">
        <h1 class="prestige-title" data-morph data-morph-duration="1500">Voies de prestige</h1>
        <p class="prestige-subtitle">
          ${voies.length} voies d'elite, accessibles a partir du niveau 5 (rangs 4-8).
        </p>
      </header>
      <cof2-search-grid
        .items=${voies}
        .predicate=${matches}
        .renderItem=${render}
        placeholder="Rechercher une voie de prestige..."
      ></cof2-search-grid>
    </div>
  `;
}
